@if (config) {
  <commerce-product-header-commerce [config]="config"> </commerce-product-header-commerce>
}
